var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.49108 3H1.47404C0.578773 3 0 2.33303 0 1.49948C0 0.648306 0.5964 0 1.50865 0C2.42091 0 2.98269 0.648306 3 1.49948C3 2.33303 2.42091 3 1.49108 3ZM3 14H0V5H3V14ZM11.0519 13.9998H13.9999L14 8.95797C14 6.25705 12.5456 5 10.6057 5C9.04046 5 8.33968 5.85348 7.94841 6.45221V5.20672H5C5.03886 6.03183 5 14 5 14H7.94841V9.0891C7.94841 8.8263 7.96754 8.56414 8.04549 8.37598C8.25855 7.85096 8.74368 7.30738 9.55814 7.30738C10.6253 7.30738 11.0519 8.11371 11.0519 9.29535V13.9998Z"}));
}

Linkedin.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
